import { useState, useEffect, memo } from 'react'
import dynamic from 'next/dynamic'
import { loader } from '@monaco-editor/react'

const MonacoEditor = dynamic(() => import('@monaco-editor/react'), {
  ssr: false,
  loading: () => <div>Loading editor...</div>,
})

// DO not remove
loader.config({ paths: { vs: '/js/vs' } })

const WithEditorComponent = ({
  setScript,
  children = '',
  language = 'html',
  height,
}: any) => {
  const [value, setValue] = useState<any>(children || '')

  useEffect(() => {
    setScript && setScript(value)
  }, [setScript, value])

  useEffect(() => {
    setValue(children)
  }, [children, setValue])

  return (
    <MonacoEditor
      onChange={setValue}
      value={value}
      language={language}
      defaultValue={children}
      theme='vs-dark'
      height={height ?? '50vh'}
      width={'100%'}
    />
  )
}

export const WithEditor = memo(WithEditorComponent)
